import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import LandingPromoContainer from 'components/ads/LandingPromoContainer'
import UseCasesCards from 'components/landing/sellmonitor/blocks/UseCasesCards'
import SellmonitorFeatures from 'components/landing/sellmonitor/blocks/SellmonitorFeatures'
import ExtensionPlug from 'components/landing/sellmonitor/blocks/ExtensionPlug'
import Features from 'components/landing/sellmonitor/blocks/Features'
import ConsultingBanner from 'components/landing/sellmonitor/blocks/ConsultingBanner'
import TelegramBanner from 'components/landing/sellmonitor/blocks/TelegramBanner'
import Advantages from 'components/landing/sellmonitor/blocks/Advantages'
import Pricing from 'components/landing/sellmonitor/blocks/Pricing'
import Testimonials from 'components/landing/sellmonitor/blocks/Testimonials'
import SellersCases from 'components/landing/sellmonitor/blocks/SellersCases'
import Faq from 'components/landing/sellmonitor/blocks/Faq'
import LandingSignupForm from 'components/landing/sellmonitor/blocks/LandingSignupForm'
import SellmonitorIntegration from 'components/landing/sellmonitor/blocks/SellmonitorIntegration'
import MarketplaceLinks from 'components/landing/sellmonitor/blocks/MarketplaceLinks'

const SellmonitorIndexPage: FC = () => {
  const ctx = useUserContext()

  const isSellmonitor = ctx.theme.hostType === 'sellmonitor'

  if (!isSellmonitor) {
    return null
  }

  return (
    <>
      <LandingPromoContainer />
      <UseCasesCards className="!pt-12" />
      <SellmonitorFeatures mall="wb" showMall={false} alignCenter />
      <ExtensionPlug />
      <Features />
      <ConsultingBanner />
      <Advantages />
      <Pricing />
      <SellmonitorIntegration />
      <Testimonials />
      <SellersCases malls={['wb', 'ozon']} className="!py-20" alignCenter />
      <TelegramBanner />
      <Faq className="!pb-0" />
      <LandingSignupForm
        className="!pb-0"
        title="Готовы попробовать Sellmonitor?"
        description="Получите бесплатный доступ к сервису и убедитесь во всём сами"
      />
      <MarketplaceLinks />
    </>
  )
}

export default SellmonitorIndexPage
